import "./frontpage.scss";
import "../../src-utilities/footer";
import "../../src-utilities/header";
import JustValidate from "../../../node_modules/just-validate/dist/just-validate.es";

document.getElementById("hero-get-start-now").addEventListener("click", (e) => {
  document.getElementById("ourproducts").scrollIntoView({ behavior: "smooth" });
});

const getInTouch = document.getElementById("get-in-touch-form");

const getInTouchData = new JustValidate(getInTouch);

getInTouchData
  .addField("#git-fullName", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
    {
      rule: "customRegexp",
      value: /^(?=\S)([A-Za-z.]+(?:\s+[.A-Za-z]+){1,})$/,
      errorMessage: "Enter Valid Full Name",
    },
  ])
  .addField("#git-companyName", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
  ])
  .addField("#git-email", [
    {
      rule: "required",
    },
    {
      rule: "email",
    },
    {
      rule: "customRegexp",
      value:
        /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/,
      errorMessage: "Please enter a valid email",
    },
  ])
  .addField("#git-jobtitle", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
  ])
  .addField("#git-country", [
    {
      rule: "required",
    },
    {
      validator: (value) => {
        return value !== "none";
      },
      errorMessage: "The field is required",
    },
  ])
  .addField("#git-lcode", [
    {
      rule: "required",
      errorMessage: "Code is required",
    },
    {
      validator: (value) => {
        return value !== "none";
      },
      errorMessage: "The field is required",
    },
  ])
  .addField("#git-phone", [
    {
      rule: "required",
      errorMessage: "The field is required",
    },
    {
      rule: "minLength",
      value: 4,
      errorMessage: "Minimum length is 4",
    },
    {
      rule: "customRegexp",
      value: /^[0-9]+$/,
    },
    {
      rule: "maxLength",
      value: 15,
      errorMessage: "Maximum length is 15",
    },
    {
      rule: "number",
    },
  ])
  .addField("#git-message", [
    {
      rule: "required",
    },
  ]);

let GoogleSendURL =
  "https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec";

let loader = document.querySelector(".loader");

getInTouch.addEventListener("submit", async (event) => {
  event.preventDefault();
  if (getInTouchData.isValid == false) {
    return false;
  }

  loader.classList.add("active");

  let formData = new FormData(event.target);

  let fullName = formData.get("lfirstname").split(" ");
  let firstName, lastName;
  [firstName, ...lastName] = fullName;
  lastName = lastName.join(" ");
  formData.set("lfirstname", firstName);
  formData.set("llastname", lastName);
  formData.append("sendurlvalue", window.location.href);
  formData.append("lsource", "Website Form - product contactus");

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  // Initiate the Sales IQ visitor data
  if (window.$zoho && window.$zoho.salesiq) {
    try {
      $zoho.salesiq.visitor.uniqueid();
      $zoho.salesiq.visitor.name(firstName + " " + lastName);
      $zoho.salesiq.visitor.email(formData.get("lemail"));
      console.log("SalesIQ Name/Email set");
    } catch (error) {
      console.warn("SalesIQ Error:", error);
    }
  }

  const raw = JSON.stringify({
    firstName: formData.get("lfirstname"),
    lastName: formData.get("llastname"),
    company: formData.get("lcompany"),
    email: formData.get("lemail"),
    jobTitle: formData.get("ljobtitle"),
    country: formData.get("lcountry"),
    phone: formData.get("phonecode") + " " + formData.get("lphone"),
    description: formData.get("Description"),
    leadSource: formData.get("lsource"),
    websiteVisitURL: window.location.href,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const googleRequestOptions = {
    method: "GET",
    redirect: "follow",
  };

  let request = "?";
  [...formData].forEach(([key, value], index) => {
    request += `${index === 0 ? "" : "&"}${key + "=" + value}`;
  });

  // Request 1: Main Backend
  const backendRequest = fetch(
    "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
    requestOptions,
  );

  // Request 2: Update the Google Sheet Data
  const googleRequest = fetch(GoogleSendURL + request, googleRequestOptions);

  // Waiting until these request get's completed
  try {
    await Promise.allSettled([backendRequest, googleRequest]);
  } catch (e) {
    console.error("API Error", e);
  }

  // Redirect
  window.location.href = "https://products.cyntexa.com/success";
});

BindEvent();

function BindEvent() {
  const accordions = document.querySelectorAll(".accordian");

  accordions.forEach((acc) => {
    acc.addEventListener("click", function (e) {
      e.preventDefault(); 
      const parentWrapper = this.closest(".accordiancover");

      const isActive = parentWrapper.classList.contains("active");

      document.querySelectorAll(".accordiancover").forEach((wrapper) => {
        wrapper.classList.remove("active");

        const btn = wrapper.querySelector(".accordian");
        if (btn) btn.setAttribute("aria-expanded", "false");
      });

      if (!isActive) {
        parentWrapper.classList.add("active");
        this.setAttribute("aria-expanded", "true");
      }
    });
  });
}
